import { LocalDateType } from '@app/models';
import { gql } from 'apollo-angular';

export interface TimetablePeriod {
  id: number;
  firstDate?: LocalDateType;
  lastDate?: LocalDateType;
  x11Date?: LocalDateType;
  x10AndAHalfDate?: LocalDateType;
  x8Date?: LocalDateType;
  x7AndAHalfDate?: LocalDateType;
  x6Date?: LocalDateType;
  x5Date?: LocalDateType;
  x4AndAQuarter?: LocalDateType;
  x3AndAHalfDate?: LocalDateType;
  x2Date?: LocalDateType;
  x1Date?: LocalDateType;
  startDossierCreation?: LocalDateType;
  activeForDossierCreation?: boolean;
}

export const baseTimetablePeriod = gql`
  fragment baseTimetablePeriod on TimetablePeriod {
    id
    firstDate
    lastDate
  }
`;

export const timetablePeriod = gql`
  fragment timetablePeriod on TimetablePeriod {
    ...baseTimetablePeriod
    x11Date
    x10AndAHalfDate
    x8Date
    x7AndAHalfDate
    x6Date
    x5Date
    x4AndAQuarter
    x3AndAHalfDate
    x2Date
    x1Date
    startDossierCreation
    activeForDossierCreation
  }
  ${baseTimetablePeriod}
`;
